import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { CrossTabChannel } from './cross-tab-channel';

/**
 * Simple event service for tool item changes and deletions.
 * Data stores notify this service, ToolComparisonService watches and reacts.
 * but can be used by any component/service that needs to react to item changes/deletions.
 *
 * Item changes and deletions are also broadcast to other browser tabs so open
 * views (e.g. tool comparison) stay in sync without a manual refresh.
 */
@Injectable({
  providedIn: 'root',
})
export class ToolItemEventsService {
  private itemChanged = new Subject<string>();
  private itemDeleted = new Subject<string>();

  readonly itemChanged$ = this.itemChanged.asObservable();
  readonly itemDeleted$ = this.itemDeleted.asObservable();

  // Re-emit remote events locally only — never re-broadcast (avoids echo loops).
  private readonly changedChannel = new CrossTabChannel<string>('tool-item-changed', itemId =>
    this.itemChanged.next(itemId)
  );
  private readonly deletedChannel = new CrossTabChannel<string>('tool-item-deleted', itemId =>
    this.itemDeleted.next(itemId)
  );

  notifyItemChanged(itemId: string): void {
    this.itemChanged.next(itemId);
    this.changedChannel.post(itemId);
  }

  notifyItemDeleted(itemId: string): void {
    this.itemDeleted.next(itemId);
    this.deletedChannel.post(itemId);
  }
}
